<template>
  <div>
    <el-dialog
      :visible.sync="faltantes"
      width="360px"
      :top="'3vh'"
      :center="true"
      custom-class="modal-inner"
      :lock-scroll="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :destroy-on-close="false"
    >
  
      <p style="font-size: 16px; text-align: left">
        <strong>PEDIDO INCOMPLETO</strong>
        <br>
       Al momento de la preparación no teníamos stock de los productos detallados más abajo. Ya hemos realizado el reintegro del pago de estos productos y podés chequearlos en la pestaña PAGOS
      </p>
         <strong>Productos no enviados</strong>
  <ul class="data-vtex-ul">
      <li
        v-for="i in productos"
        :key="i.uniqueId"
        :class="getClassItem(i)"
      >
    
    <el-image :src="i.imageUrl" :fit="'contain'" class="thumbnail">
      <div slot="error" class="image-slot">
        <i class="el-icon-picture-outline"></i>
      </div>
    </el-image>
        <p>
            <span v-if="getRealQuantity(i)">
             {{ getRealQuantity(i) }} {{ getRealQuantity(i) | pluralize(["unidad", "unidades"]) }} -
            </span>
             {{ i.name.toLowerCase() }} <br />
          <span v-if="i.modificado">
           
            <strong
              style="font-size: 12px; color: #f44336; font-weigth: 500"
              v-if="i.quantity - i.cambios.quantity == 0"
            >
              PRODUCTO ELIMINADO ({{ i.cambios.quantity }}
              {{ i.cambios.quantity | pluralize(["UNIDAD", "UNIDADES"]) }}) POR
              FALTA DE STOCK
            </strong>
            <strong
              style="font-size: 12px; color: #f44336; font-weigth: 500"
              v-if="i.quantity - i.cambios.quantity > 0"
            >
              ENTREGA PARCIAL SE QUITARON {{ i.cambios.quantity }}
              {{ i.cambios.quantity | pluralize(["UNIDAD", "UNIDADES"]) }} DEL
              PRODUCTO POR FALTA DE STOCK
            </strong>
            <br>
          </span>
          <small style="padding: 0px" v-if="i.sellingPrice">
            Precio: {{ (i.listPrice / 100) | currency }} 
            <span v-if="(i.listPrice - i.sellingPrice)">
                - Precio con descuento: {{(i.sellingPrice / 100) | currency }}
            </span>
            <span v-if="(i.listPrice - i.sellingPrice)">
              - Descuento: {{getDescuento(i)}}
            </span>
           
          </small>
          <small v-else>
            <span v-if="i.sellingPrice">
 Precio: {{(i.sellingPrice / 100) | currency }}
            </span>
            <span v-else>
              Precio: 0 - Corresponde a promoción 2x1  
            </span>
                
          </small>
        </p>
      </li>
    </ul>
 
    <el-button type="primary" size="default" style="display:block; width:100%; padding:20px; margin-top:10px" @click="faltantes = false">Aceptar</el-button>
    <el-button type="warning" size="default" style="display:block; width:100%; padding:20px; margin-top:10px; margin-left:0" @click="seleccionarProductos">Faltan otros productos</el-button>
    
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { EventBus } from "@/event-bus";
export default {
  data() {
    return {
      faltantes: false,
      recopilando: true,
      productos:[]
    };
  },
  created() {
    EventBus.$on("verFaltantes", (d) => {
      this.faltantes = d.length ? true : false;
      this.productos = d
     
    });

   
      EventBus.$on('enviarFormCancelar', (m) => {
          this.cancelar(m)
      })
  },
    computed: {
    ...mapGetters(["pedidoCancelado", "messages"]),
  },

  methods: {
     ...mapActions({
      vuexCancelarPedido: "cancelarPedido",
      vuexIniciarReclamoLocal: "iniciarReclamoLocal",
      vuexGuardarMensaje: "guardarMensaje",
      vuexCargando: "isLoading",
      vuexCrearCasoWebCentrix: "crearCasoWebCentrix",
    }),

     async cancelar(m) {
      let datosWc = {
        content: `Hola, me comunico para solicitar la ${m.motivo.toLowerCase()}. <br> Motivo: ${m.causa}`,
        dni: this.$store.state.datos["dni"],
        email: this.$store.state.datos["mail_d"]
          ? this.$store.state.datos["mail_d"]
          : "",
        fechaVtex: this.$date(this.$store.state.datos.vtex_fecha.date).format(
          "DD/MM/YYYY HH:mm"
        ),
        motivoId: m.id,
        nombre: this.$store.state.datos["nombre"],
        envio: this.$store.state.datos["envio"],
        status: "open",
        tags: ["Arrepentimiento / Cancelado"],
       telefono: this.$store.state.datos["telefono"],
        totalOperacion: this.$store.state.datos.importe / 100,
        vtex_id: this.$store.state.datos.vtex_id,
        wcTipo: m.wc_tipo,
        priority: "high",
        motivo_id: m.id
      };
      // this.vuexCrearCasoWebCentrix({ datosWc, motivoIngresado: m });
      let result = this.vuexCancelarPedido({ datosWc, motivoIngresado: m });
      result.then(res => {
console.log('vuexCancelarPedido', res);

EventBus.$emit('procesarArrepentimiento', res)


      })
      
    },


    seleccionarProductos()
    {
       this.faltantes = false
       EventBus.$emit('verListadoProductos', true)
    },
    cerrarModal() {
      EventBus.$emit("cerrarModal", 1);
    },
    getDescuento(i)
    {
        let lista  = i.listPrice / 100
        let venta  = i.sellingPrice / 100

        let descuento = 100 - (((venta * 100 ) / lista))
       return descuento.toFixed(1) + '%'
    },
    getRealQuantity(i) {
      let quantity = 0;

      if (i.cambios && i.cambios.quantity) {
        quantity = i.quantity - i.cambios.quantity;
      } else {
        quantity = i.quantity;
      }

      return quantity;
    },
   
    getTotalPago(pagos) {
      let total = pagos.map((p) => p.value).reduce((a, b) => a + b);

      return total / 100;
    },
    getClassItem(i) {
      let clase = "item-ok";
      if (i.modificado) {
        if (i.quantity - i.cambios.quantity == 0) {
          clase = "item-cambio";
        } else {
          clase = "item-cambio-parcial";
        }
      }

      return clase;
    },
  },
};
</script>

<style lang="scss" scoped>
.detalle {
  position: relative;
  margin: 20px;
}

.data-vtex-ul {
  list-style-type: none;
  padding: 0;
  width: 100%;
  // border: 1px solid #f1f1f1;
  margin: 0;
}

.data-vtex-ul > li {
  display: flex;
  align-items: center;
  //  padding: 5px 5px;
  border: 1px solid #f1f1f1;
  margin-bottom: 5px;
}

.data-vtex-ul > li > p {
  text-transform: capitalize;
  text-align: left;
  word-break: break-word;
  font-size: 13.5px;
  font-weight: 500;
  color: #333;
  line-height: 1.2;
}
i.el-icon-picture-outline{
    font-size: 30px !important;
    display: block;
    margin: 0 auto;
    text-align: center;
        color: #fadedc;
}
.data-vtex-ul > li > img, .thumbnail {
  width: 40px;

  text-align: center;
  padding: 4px;
//   border-right:1px solid #ddd;
  margin-right: 10px;
  height: 100%;
  
}
.items-titulo {
  margin: 0;
  padding: 10px;
  background: #f1f1f1;
  // width: 100%;
  text-align: left;
  margin-bottom: 5px;
}

.items-retiro {
  margin: 0;
  padding: 20px;
  margin-top: 10px;
  background: #fafafa;
  width: 94.8%;
  text-align: center;
  margin-bottom: 10px;
}
.item-ok {
  border-left: 2px solid #cddc39;
}
.item-cambio {
  border-left: 2px solid #f44336;
  background: rgb(244 67 54 / 6%);
}
.item-cambio-parcial {
  border-left: 2px solid #f4ce36;
  background: rgb(255 235 59 / 15%);
}
.table-items > tr > th {
  padding: 3px 10px;
}
</style>